import {
    Environment,
    HeaderConfigurationOptions,
    HeaderLocaleOptions,
} from './types';

const HEADER_SERVICE_PATH = '/api/v1/header/aggregate';
const HEADER_SERVICE_PUBLIC_BASE_URL = '/api/shop-header';
enum HeaderServiceInternalHost {
    DEV = 'https://shop-header-api-develop.private.zooplus.net',
    PROD = 'https://shop-header-api.private.zooplus.net',
    RELEASE = 'https://shop-header-api-release.private.zooplus.net',
    BETA = 'https://shop-header-api-beta.private.zooplus.net',
}
enum DiscoverBackendHost {
    DEV = 'https://discover-backend-dev.private.zooplus.net',
    PROD = 'https://discover-backend.private.zooplus.net',
}

export function serializeConfigurationOptions(
    configurationOptions: HeaderConfigurationOptions,
): string {
    const queryParamKeys: (keyof HeaderConfigurationOptions)[] = [
        'showCart',
        'showCategories',
        'showMultilanguage',
        'showSearch',
        'searchFlyoutOpen',
    ];

    return queryParamKeys
        .map(
            (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                    configurationOptions[key]!,
                )}`,
        )
        .join('&');
}

export function serializeBaseUrl(
    environment: Environment,
    localeOptions: HeaderLocaleOptions,
    enableDiscoverBackend = false,
): string {
    const { domain, locale } = localeOptions;

    const encodedDomain = encodeURIComponent(domain);
    const encodedLocale = encodeURIComponent(locale);
    const path = `${HEADER_SERVICE_PATH}/${encodedDomain}/${encodedLocale}`;

    const isClientSide = typeof window !== 'undefined';
    if (isClientSide) {
        return `${HEADER_SERVICE_PUBLIC_BASE_URL}${path}`;
    }

    const internalBaseUrl = enableDiscoverBackend
        ? getDiscoverBackendBaseUrl(environment)
        : getInternalBaseUrl(environment);
    return `${internalBaseUrl}${path}`;
}

function getInternalBaseUrl(environment: Environment): string {
    switch (environment) {
        case 'prod':
            return HeaderServiceInternalHost.PROD;
        case 'beta':
            return HeaderServiceInternalHost.BETA;
        case 'dev':
            return HeaderServiceInternalHost.DEV;
        case 'release':
            return HeaderServiceInternalHost.RELEASE;
    }
}

function getDiscoverBackendBaseUrl(environment: Environment): string {
    // discover-backend has no dedicated beta/release deployment yet, so beta
    // is promoted to prod's instance while release falls back to dev's.
    switch (environment) {
        case 'prod':
        case 'beta':
            return DiscoverBackendHost.PROD;
        case 'dev':
        case 'release':
            return DiscoverBackendHost.DEV;
    }
}
